import Logo from '@/components/template/Logo'
import Alert from '@/components/ui/Alert'
import SignInForm from './components/SignInForm'
import ActionLink from '@/components/shared/ActionLink'
import useTimeOutMessage from '@/utils/hooks/useTimeOutMessage'
import { useThemeStore } from '@/store/themeStore'
import { usePage } from '@inertiajs/react'
import { useState } from 'react'
import { consumeAccountRemovalNotice } from '@/utils/accountRemovalNotice'

type SignInProps = {
    signUpUrl?: string
    forgetPasswordUrl?: string
    disableSubmit?: boolean
}

export const SignInBase = ({
    signUpUrl = '/register',
    forgetPasswordUrl = '/forgot-password',
    disableSubmit,
}: SignInProps) => {
    const [message, setMessage] = useTimeOutMessage()
    const [accountRemovalNotice] = useState(consumeAccountRemovalNotice)
    const mode = useThemeStore((state) => state.mode)
    const { registrationEnabled } = usePage<{ registrationEnabled: boolean }>().props

    return (
        <>
            <div className="mb-10 flex items-center gap-4">
                <Logo
                    type="streamline"
                    mode={mode}
                    imgClass=""
                    logoWidth={60}
                />
                <div>
                    <h2 className="mb-2">Welcome back!</h2>
                    <p className="font-semibold heading-text">
                        Please enter your credentials to sign in!
                    </p>
                </div>
            </div>
            {message && (
                <Alert showIcon className="mb-4" type="danger">
                    <span className="break-all">{message}</span>
                </Alert>
            )}
            {accountRemovalNotice && (
                <Alert showIcon className="mb-4" type="success" duration={0}>
                    <span>{accountRemovalNotice}</span>
                </Alert>
            )}
            <SignInForm
                disableSubmit={disableSubmit}
                setMessage={setMessage}
                passwordHint={
                    <div className="mb-7 mt-2">
                        <ActionLink
                            to={forgetPasswordUrl}
                            className="font-semibold heading-text mt-2 underline"
                            themeColor={false}
                        >
                            Forgot password
                        </ActionLink>
                    </div>
                }
            />

            {registrationEnabled && (
                <div>
                    <div className="mt-6 text-center">
                        <span>{`Don't have an account yet? `}</span>
                        <ActionLink
                            to={signUpUrl}
                            className="heading-text font-bold"
                            themeColor={false}
                        >
                            Sign up
                        </ActionLink>
                    </div>
                </div>
            )}
        </>
    )
}

const SignIn = () => {
    return <SignInBase />
}

export default SignIn
